import React, { useEffect, useState } from 'react'
import Divider from './Divider'
import {StepDesc, StepHeader} from './SectionHeader'
import { useLocalStorage, useLocalStorageWithParsing } from '../Context/LocalStorageContext'
import ProofPossession from '../ProofPossession/ProofPossession'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Buffer } from 'buffer'
import MPKArea from './MPKArea'
import Alerts from '../Alerts/Alerts'
import { ArrowUpRight, Loading } from '../../svg/Icons'
import GoogleAnalytics from '../GA'

const RequestIDT = () => {

    const navigate= useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [loadingIDT, setLoadingIDT] = useState(false);
    const [mpk, setMpk] = useLocalStorage("mpk");

    const [_, setSteps] = useLocalStorageWithParsing("steps", 0)

    const [idToken, setIdToken] = useState<string>("");
    const [idTokenParsed, setIdTokenParsed] = useState<any>(null);
    const [isValidIDT, setIsValidIDT] = useState(false);

    useEffect(() => {


        let token_mpk = searchParams.get("request_mpk_token");

        //---------------------------------

        let tokenStr = searchParams.get("id_token");
        setIdToken(tokenStr || "");

        if (tokenStr && tokenStr !== "") {
            let splitArr = tokenStr.split(".")
            if (splitArr.length === 3) {
                try {
                    let decoded = JSON.parse(Buffer.from(splitArr[1], "base64").toString());
                    setIdTokenParsed(decoded);
                } catch (e) {
                    console.log(e);
                    setIdTokenParsed(null);
                }
            } else {
                setIdTokenParsed(null);
            }
        } else {
            setIdTokenParsed(null);
        }

    }, [searchParams])

    useEffect(() => {
        if(idTokenParsed !== null) {
            setIsValidIDT(validToken());
        }

    }, [idTokenParsed])

    function requestVC(){
        setLoadingIDT(true);
        let apiUrl = (process.env.REACT_APP_ARKG_API_URL) || "http://localhost:4000/api/v1";
        let apiPrefix = process.env.REACT_APP_ARKG_LOGIN_ENDPOINT || "/auth/login";
        fetch(`${apiUrl+apiPrefix}?scope=${process.env.REACT_APP_AUTH0_REQUEST_IDT_SCOPE}`)
            .then(res => res.json())
            .then(json => {
                window.location.href = json;
            })
            .catch(err => {
                console.log(err);
                setLoadingIDT(true);
                navigate("/idt/v2/error",{state:{"error": err}});
            });
    }

    function validToken(){
        if(idTokenParsed && idTokenParsed !== undefined && idTokenParsed.hasOwnProperty("mynext.id.credential")){
       
            if(idTokenParsed["mynext.id.credential"].hasOwnProperty("credentialSubject")){
             
                setSteps(3);
                return true;
            }
            
        }
        
        return false;
    }

    const handleJWTView = () => {
        const jwtURL = `https://jwt.io/#id_token=${encodeURIComponent(idToken)}`;
        window.open(jwtURL, "_blank");
    };


    return (
        <div className=" flex flex-col w-full ">

            <MPKArea mpk={mpk ?? "{}"} title={"Master Public Key"}/>

            { !isValidIDT &&  <Alerts step="alert_registered_master_key"/>}
           
            <div className="flex flex-col mt-12 gap-4">
                <StepHeader step="step_5_request_IDT" />

                <div>
                    <StepDesc step="step_5_request_IDT" />
                    <p className='text-gray-500 leading-loose text-base font-normal'>Click <span className="font-bold text-base text-primary-600" >Request IDT++</span> to obtain your tokens.</p>
                </div>

                <div className='flex flex-col gap-2 xsm:flex-row xsm:gap-4'>
                    <button onClick={() => {requestVC(); GoogleAnalytics("Request IDT", "btn_requestIDT", "Button to request IDT")}} disabled={loadingIDT} className="button-primary my-2 dark:bg-primary-800">
                        {!loadingIDT ? <>Request IDT++ </> : <><Loading/>Requesting IDT++</>} 
                    </button>

                    { isValidIDT && 
                        <div>
                            <button onClick={() => {handleJWTView(); GoogleAnalytics("Request IDT", "btn_inspectIDT", "Button to inspect IDT in jwt.io")}} className="flex gap-2 my-2 text-sm font-medium text-primary-700 pr-5 py-2.5 items-center min-w-[140px] text-center justify-center align-middle">
                                Inspect the IDT++ <ArrowUpRight className='size-4 text-primary-700' />
                            </button>
                        </div> 
                    }
                </div>

                { isValidIDT &&  <Alerts step="alert_requested_IDT"/>}
             
            </div>

            { isValidIDT && <ProofPossession/>}
               

        </div>
    )
}

export default RequestIDT
